export default function QuoteAuthor({author, role}) {
    return (
        <div>
            <h3 className="h5 mb-1">{author}</h3>
            <p className="text-muted mb-0">{role}</p>
        </div>
    )
}